import { JSX, useContext, useEffect, useMemo, useState } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import PageSection from "@app/shared/PageSection";
import { SearchBox } from "@app/shared/SearchBox";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { WizardStepProps } from "@app/exceptions/contexts/interfaces";
import { CreateExceptionsContext } from "@app/exceptions/contexts/CreateExceptionsContext";
import CreateExceptionsStateAccordionRadioButtons from "@app/exceptions/import/CreateExceptionsStateAccordionRadioButtons";

const CreateExceptionsServiceArea = (props: WizardStepProps): JSX.Element => {

  const wizardContext = useContext(CreateExceptionsContext);
  const [serviceAreaSearchString, setServiceAreaSearchString] = useState("");

  useEffect(() => {
    wizardContext.updateRegionVisibility(serviceAreaSearchString);
  }, [serviceAreaSearchString]);

  useEffect(() => {
    props.pageIsValid(!wizardContext.loading && wizardContext.selectedServiceArea !== null);
  }, [wizardContext.selectedServiceArea]);

  const renderedRegions = useMemo(() => {
    return wizardContext.serviceAreas.filter((state) => state.isVisible).map((state) =>
      <CreateExceptionsStateAccordionRadioButtons key={state.displayName + serviceAreaSearchString} state={state} />
    );
  }, [wizardContext.serviceAreas]);

  return (
    <PageSection>
      <div className="container mt-3 p-0">
        {wizardContext.showChangeWarning && (
          <QESAlert type="warning" persist={true} classNames="mt-3">Changing anything on this page will reset later steps.</QESAlert>
        )}

        {wizardContext.error && (
          <QESAlert type="danger" persist={true} classNames="mt-3">
            {wizardContext.error}
          </QESAlert>
        )}
      </div>

      <div className="container mt-3">
        <SearchBox
          escapeSearchValue={true}
          fieldsetClass="row"
          inputLabel="Search Counties"
          testId="create-exceptions-search-service-areas"
          onSubmit={(value: string) => setServiceAreaSearchString(value)}
        />
      </div>

      <div className="container">
        {wizardContext.loading ? <LoadingSpinner /> : (
          <div className="row">
            <div className="w-100 px-0">
              <div className="border">
                <div className="create-exceptions__wizard-page-subtitle">
                  Service Areas
                </div>
                {renderedRegions}
              </div>
            </div>
          </div>
        )}
      </div>
    </PageSection>
  );
}

export default CreateExceptionsServiceArea;